const WhatIsRoba = () => {
    return (
        <div className="container">
            <div className="border-box">
                <h3>ROBA è un marketplace geolocalizzato per scambiarsi oggetti usati</h3>
            </div>
        </div>
    )
}

export default WhatIsRoba;